export default {
    "DeFi Binance": "DeFi Binance",
    "流动性挖矿": "Likidite madenciliği",
    "加入节点， 开始挖矿": "Düğüme katıl, madenciliğe başla",
    "参 与": "Katıl",
    "矿池数据": "Havuz verileri",
    "总产量": "Toplam üretim",
    "有效节点": "Aktif düğümler",
    "参与者": "Katılımcılar",
    "用户收入": "Kullanıcı geliri",
    "挖矿榜单": "Madencilik sıralaması",
    "流动性挖矿收入": "Likidite madenciliği geliri",
    "输出记录": "Çıkış kaydı",
    "地址": "Adres",
    "数量": "Miktar",
    "帮助中心": "Yardım Merkezi",
    "希望它可以帮助你": "Umarız yardımcı olur",
    "安全保障": "Güvenlik garantisi",
    "我们有安全的审计报告": "Güvenli denetim raporlarımız var",
    "伙伴": "Ortaklar",
    "我们的商业伙伴": "İş ortaklarımız",
    "首页": "Ana Sayfa",
    "我的矿池": "Benim havuzum",
    "提取": "Çekim",
    "账户": "Hesap",
    "总挖矿金额": "Toplam madencilik miktarı",
    "可更换": "Değiştirilebilir",
    "收益率": "Getiri oranı",
    "币池名称": "Havuz adı",
    "最低金额": "Minimum tutar",
    "收益率/24小时": "Getiri oranı/24 saat",
    "挖矿记录": "Madencilik kaydı",
    "金额": "Tutar",
    "描述": "Açıklama",
    "时间": "Zaman",
    "已参与": "Katıldı",
    "质 押": "Stake",
    "已质押": "Stake edildi",
    "记录": "Kayıt",
    "兑换": "Dönüştür",
    "从": "Başlangıç",
    "全部": "Tümü",
    "至": "Bitiş",
    "价格": "Fiyat",
    "确认": "Onayla",
    "矿池收益": "Havuz geliri",
    "今日收益": "Bugünkü gelir",
    "普通矿池": "Standart havuz",
    "高级矿池": "Gelişmiş havuz",
    "全部的": "Hepsi",
    "可用的": "Mevcut",
    "申请加入": "Katılım talebi",
    "推荐朋友": "Arkadaş öner",
    "一起赚取加密货币": "Birlikte kripto kazanın",
    "查看详情": "Detayları Gör",
    "团队": "Ekip",
    "推荐": "Referans",
    "团队规模": "Ekip boyutu",
    "直接发起人": "Doğrudan sponsor",
    "总收入": "Toplam gelir",
    "今天的收入": "Bugünkü gelir",
    "我的推荐链接": "Benim referans linkim",
    "复制": "Kopyala",
    "1. 获取链接": "1. Linki al",
    "2. 邀请朋友": "2. Arkadaşlarını davet et",
    "3. 赚取加密货币": "3. Kripto kazanın",
    "等级": "Seviye",
    "1 级": "Seviye 1",
    "2 级": "Seviye 2",
    "3 级": "Seviye 3",
    "用户地址": "Kullanıcı adresi",
    "币种": "Token",
    "说明": "Detaylar",
    "状态": "Durum",
    "定时收益": "Zamanlanmış gelir",
    "今日预收益": "Bugünkü tahmini gelir",
    "累计收益": "Biriken gelir",
    "将矿池收益的BNB兑换成USDT后立即到账": "Havuz gelirini BNB'den USDT'ye dönüştür, hemen yatır",
    "将USDT提取后会在24小时内到达你的钱包": "USDT çekimi 24 saat içinde cüzdana ulaşır",
    "天": "Gün",
    "高级矿池收益": "Gelişmiş havuz geliri",
    "质押收益": "Stake geliri",
    "下次收益": "Sonraki gelir",
    "当前收益率": "Mevcut getiri oranı",
    "昨日收益": "Dünkü gelir",
    "普通矿池收益率": "Standart havuz getiri oranı",
    "高级矿池收益率": "Gelişmiş havuz getiri oranı",
    "高级矿池限时开放": "Gelişmiş havuz sınırlı süre açık",
	"公告":"duyuru",
	"我知道了":"TAMAM"
};
